<template>
  <div class="result">
    <img :src="imgData" @click="previewImg" class="save-img" data-rlog="result.img">
    <img src="../assets/words.png" class="btn">
  </div>
</template>

<script>

  module.exports = {
    data: function () {
      return {
        sname: "",
        blessing: "",
        imgData: "",
        isAndroidYd: false,
      }
    },
    components: {},
    ready: function () {
      let self = this
      self.shareText(true)

      self.getInfo()
      setTimeout(function () {
        self.getInfo()
      }, 300)
      self.isAndroidYd = ydk.isAndroid && ydk.isYD
    },
    methods: {
      getInfo: function () {
        const self = this
        self.sname = decodeURIComponent(self.$route.query.sname) || ""
        self.blessing = self.$route.query.blessing || ""
        self.drawImg()
      },
      getTrueLength: function (str) {               //获取字符串的真实长度（字节长度）
        if (!str) return
        var len = str.length, truelen = 0;
        for (var x = 0; x < len; x++) {
          if (str.charCodeAt(x) > 128) {
            truelen += 2;
          } else {
            truelen += 1;
          }
        }
        return truelen;
      },
      cutString: function (str, leng) {             //按字节长度截取字符串，返回substr截取位置
        if (!str) return
        var len = str.length || 0, tlen = len, nlen = 0;
        for (var x = 0; x < len; x++) {
          if (str.charCodeAt(x) > 128) {
            if (nlen + 2 < leng) {
              nlen += 2;
            } else {
              tlen = x;
              break;
            }
          } else {
            if (nlen + 1 < leng) {
              nlen += 1;
            } else {
              tlen = x;
              break;
            }
          }
        }
        return tlen;
      },
      getPixelRatio: function (context) {
        var backingStore = context.backingStorePixelRatio ||
          context.webkitBackingStorePixelRatio ||
          context.mozBackingStorePixelRatio ||
          context.msBackingStorePixelRatio ||
          context.oBackingStorePixelRatio ||
          context.backingStorePixelRatio || 1;
        return (window.devicePixelRatio || 1) / backingStore;
      },
      drawImg: function () {
        const self = this
        const canvas = document.createElement("canvas")
        const ctx = canvas.getContext('2d')
        const image = new Image()
        image.src = "http://shared.youdao.com/market/2018teacher/image/canvas_bg.png"
        //image.src = "http://10.236.20.217:8080/static/img/canvas_bg.bf700fb.jpg"
        image.crossOrigin = "anonymous"

        let ratio = self.getPixelRatio(ctx)

        image.onload = function () {
          canvas.width = image.width / 2 * ratio
          canvas.height = image.height / 2 * ratio
          canvas.style.maxWidth = "100%"
          canvas.style.maxHeight = "100%"
          ctx.drawImage(image, 0, 0, image.width / 2 * ratio, image.height / 2 * ratio)

          ctx.clearRect(0, 0, ctx.width, ctx.height);
          ctx.font = 14 * ratio + "px Arial"
          ctx.fillStyle = "#000"
          ctx.textAlign = "left"
          ctx.textBaseline = "alphabetic"
          /*ctx.fillText(" 老师", 45 * ratio, 45 * ratio)*/

          for (let i = 0; i < self.getTrueLength(self.blessing); i++) {
            const tmpText = self.cutString(self.blessing, 30)
            ctx.fillText(self.blessing.substr(0, tmpText).replace(/^\s+|\s+$/, ""), 35 * ratio, i * 25 * ratio + 82 * ratio);
            self.blessing = self.blessing.substr(tmpText);
          }
          ctx.fillText(self.sname, 195 * ratio, 276 * ratio)
          /*ctx.fillText("2017年9月10日", 185 * ratio, 250 * ratio)*/

          self.imgData = canvas.toDataURL("image/png")
        }
      },
      previewImg: function () {
        const self = this

        ydk.previewImage({
          current: self.imgData, // 当前显示的图片链接
          urls: [self.imgData], // 需要预览的图片链接列表
          success: function (res) {
          }
        });
      },
      shareText: function (sli) {
        const self = this


        const shareUrl = window.location.href
        const shareImg = "http://shared.youdao.com/dict/market/2017teacher/final/static/img/icon_xin.jpg"

        ydk.share({
          silence: sli,
          shift: true,
          title: "“你们是我带过最差的一届！”“但您是我遇见过最好的老师！”",
          desc: "教师节到了，我们帮你给老师送一份礼物吧！",
          imgUrl: shareImg,
          link: shareUrl
        });
      }
    }
  }
</script>
<style scoped>
  .result {
    width: 100%;
    height: 100%;
    background: url("../assets/share_bg.png") 0 0/100% 100% no-repeat;
  }

  .save-img {
    display: block;
    width: 73%;
    margin: 29% auto 0;
  }

  p {
    line-height: 20px;
    margin-top: 5%;
    color: #fff;
    font-size: 16px;
    text-align: center;
    user-select: none;
    -webkit-user-select: none;
  }

  .btn {
    width: 67%;
    height: 12.6%;
    display: block;
    margin: 6% auto 0;
  }

  /*  @media screen and (max-width: 320px) {
      .save-img {
        width: 80%;
      }
    }

    @media screen and (min-width: 321px) and (max-width: 374px) {
      .save-img {
        width: 78%;
      }

      .btn {
        width: 30%;
        margin: 0 0 0 13%;
      }
    }

    @media screen and (min-width: 376px) and (max-width: 414px) {
      p {
        margin-top: 2%;
        font-size: 14px
      }

      .btn {
        width: 30%;
        margin: 0 0 0 13%;
      }

      .save-img {
        width: 80%;
      }
    }*/
</style>



// WEBPACK FOOTER //
// resultShare.vue?315b1785